export class KlaviyoServices {
    
    static trackingKlaviyo(eventName, data) {
        if (window.klaviyo && !!data) {
            window.klaviyo.track(eventName, data);
        }
    }

	static trackViewedItem(data) {
		if (window.klaviyo && !!data) {
			let trackedViewedData = Object.assign({}, {
				"Title": data.title,
				"ItemId": data.id,
				"SKU": data.sku,
				"Categories": data.categories ? data.categories.split(',').filter(item => item.trim() !== '') : [],
				"ImageUrl": data.image_link,
				"Url": data.link,
				"Metadata": {
					"Brand": data.brand,
					"Price": data.price,
					"CompareAtPrice": null
				}
			});

			window.klaviyo.trackViewedItem(trackedViewedData);
		}
	}

    static filterEmptyData(item) {
		return Object.keys(item).reduce((_result, _current) => {
			const value = item[_current];
			if (value !== '') {
				_result[_current] = value;
			}
			return _result;
		}, {});
	}

	static getTotalCartValue(carts) {
		var totalCartPrice =  carts.reduce((total, product) => {
			let price = product.sale_price > 0 ? product.sale_price : product.price;
            return total + (price * product.quantity);
        }, 0);

		return (Math.round(totalCartPrice * 100) / 100);
	}

	static getTotalQuantity(carts) {
		return carts.reduce((sum, product) => {
			const qty = Number(product.quantity);
			return sum + (isNaN(qty) ? 0 : qty);
		  }, 0);
	}
	
	static getDataLayer($product, attr) {
		const data = [];
		if(!!$product) {
			$product.forEach((item, index) => {
				const $dataItem = item.getAttribute(attr);
				if (!$dataItem)
					return;
				const _datalayer = JSON.parse($dataItem);
				 data.push(KlaviyoServices.filterEmptyData(_datalayer));
			});
		}
		
		return data;
	}

	static convertToNumber(numberString) {
		Number.parseFloat(numberString.replace(/,/g, ''));
	}

	static sortProductsByQuantity(products) {
		return products.sort((a, b) => b.quantity - a.quantity);
	}
} 


// WEBPACK FOOTER //
// ./client/src/core/services/klaviyo-services.js